import { FC } from 'react';

import { useQuery } from 'hooks';
import { Address } from 'types';
import { getQueryKey, removeExSpaces } from 'utils';

import { PreLoader, Typography } from 'components';

interface OfficeholderAddressProps {
  residentAddressID?: number;
}

const OfficeholderAddress: FC<OfficeholderAddressProps> = ({
  residentAddressID,
}) => {
  const { data: address, isLoading } = useQuery<Address>({
    apiName: 'address',
    path: `/${residentAddressID}`,
    enabled: !!residentAddressID,
    queryKey: getQueryKey('officeholderAddress', residentAddressID),
  });

  if (isLoading) {
    return <PreLoader />;
  }

  if (!address) {
    return null;
  }

  const addressString = removeExSpaces(
    `${address.country} ${address.state} ${address.streetType} ${address.streetName} ${address.streetNumber} ${address.postcode}`,
  );

  return <Typography.Paragraph>{addressString}</Typography.Paragraph>;
};

export default OfficeholderAddress;
